import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const whatsappLink = "https://api.whatsapp.com/send/?phone=5511936180993&text&type=phone_number&app_absent=0";

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Abrir WhatsApp para falar com um especialista Zavvi"
      title="Fale conosco pelo WhatsApp"
    >
      {/* Pulse Ring - using transform for composite animation */}
      <span 
        className="absolute inset-0 rounded-full bg-success-green/40" 
        style={{ 
          animation: 'ping 2s cubic-bezier(0, 0, 0.2, 1) infinite',
        }}
        aria-hidden="true"
      />
      
      {/* Outer Glow */}
      <span 
        className="absolute inset-0 rounded-full bg-success-green/20 blur-md scale-150" 
        aria-hidden="true"
      />
      
      {/* Button - min 48x48 for touch targets */}
      <div className="relative flex items-center justify-center w-14 h-14 min-w-[56px] min-h-[56px] rounded-full bg-success-green text-white shadow-lg transition-transform duration-300 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(34,197,94,0.5)]">
        <MessageCircle size={28} className="fill-white" aria-hidden="true" />
      </div>

      {/* Tooltip */}
      <div 
        className="absolute right-full mr-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        aria-hidden="true"
      >
        <div className="glass-card px-4 py-2 rounded-lg whitespace-nowrap text-sm font-medium text-foreground border border-success-green/30">
          Fale conosco! 💬
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
